(function () {
  var configEl = document.getElementById("sp-config");
  if (!configEl) return;

  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config.variantId) return;

  var VARIANT_ID  = String(config.variantId);
  var STORAGE_KEY = "sp_protection_on";
  var UI_ID       = "sp-toggle-widget";

  function getIsOn() {
    try {
      var val = localStorage.getItem(STORAGE_KEY);
      return val === null ? true : val === "1";
    } catch (e) { return true; }
  }

  function setIsOn(val) {
    try { localStorage.setItem(STORAGE_KEY, val ? "1" : "0"); } catch (e) {}
  }

  function findProtectionLine(cart) {
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === VARIANT_ID;
    }) || null;
  }

  function cleanupProtection() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = findProtectionLine(cart);
        if (!line) return;
        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function () {
          window.location.reload();
        });
      })
      .catch(function () {});
  }

  function addAndCheckout() {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: Number(VARIANT_ID), quantity: 1, properties: { "_sp_managed": "true" } }]
      })
    })
    .then(function ()  { window.location.href = "/checkout"; })
    .catch(function () { window.location.href = "/checkout"; });
  }

  function handleCheckoutClick() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!findProtectionLine(cart)) {
          return addAndCheckout();
        }
        window.location.href = "/checkout";
      })
      .catch(function () { window.location.href = "/checkout"; });
  }

  function interceptCheckoutButtons() {
    var buttons = document.querySelectorAll(
      "[name='checkout'], a[href='/checkout'], button[data-checkout]"
    );
    buttons.forEach(function (btn) {
      if (btn.dataset.spBound) return;
      btn.dataset.spBound = "1";
      btn.addEventListener("click", function (e) {
        if (!getIsOn()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCheckoutClick();
      });
    });
  }

  function buildWidget() {
    var checked = getIsOn();
    var el = document.createElement("div");
    el.id = UI_ID;
    el.innerHTML = [
        '<div style="display:flex;align-items:center;gap:12px;padding:12px 14px;border:1px solid #e5e5e5;border-radius:8px;margin-top:12px;margin-bottom:12px;">',
        '<div style="flex:1;min-width:0;font-size:13px;line-height:1.3;color:#111;">',
          '<span style="font-weight:700;">' + config.label + '</span>',
                    ' <span style="color:#555;font-weight:500;">(' + config.price + ')</span>',
          '<div style="font-size:11px;color:#777;line-height:1.4;margin-top:2px;">' + config.description + '</div>',
        '</div>',
        '<label style="flex-shrink:0;position:relative;display:inline-block;width:44px;height:24px;cursor:pointer;">',
          '<input id="sp-toggle-input" type="checkbox" style="opacity:0;width:0;height:0;position:absolute;"' + (checked ? ' checked' : '') + '>',
          '<span id="sp-toggle-track" style="position:absolute;inset:0;border-radius:24px;background:' + (checked ? '#2a7a2a' : '#ccc') + ';transition:background 0.2s;"></span>',
          '<span id="sp-toggle-thumb" style="position:absolute;top:3px;left:' + (checked ? '23px' : '3px') + ';width:18px;height:18px;border-radius:50%;background:#fff;transition:left 0.2s;box-shadow:0 1px 3px rgba(0,0,0,0.2);"></span>',
        '</label>',
      '</div>'
    ].join('');

    el.querySelector("#sp-toggle-input").addEventListener("change", function (e) {
      var on = e.target.checked;
      setIsOn(on);
      el.querySelector("#sp-toggle-track").style.background = on ? "#2a7a2a" : "#ccc";
      el.querySelector("#sp-toggle-thumb").style.left = on ? "23px" : "3px";
    });

    return el;
  }

  function injectUI() {
    var drawerContent = document.querySelector("#Cart-Drawer .side-panel-content");
    var hasItems = document.querySelector("#Cart-Drawer .product-cart-item--container");
    if (drawerContent && hasItems) {
      if (!drawerContent.querySelector("#" + UI_ID)) {
        drawerContent.appendChild(buildWidget());
      }
      interceptCheckoutButtons();
    }

    if (window.location.pathname === "/cart") {
      var checkoutBtn = document.querySelector("#Cart [name='checkout'], .thb-cart-form [name='checkout']");
      if (checkoutBtn) {
        var target = checkoutBtn.parentElement;
        if (target && !target.querySelector("#" + UI_ID)) {
          target.insertBefore(buildWidget(), checkoutBtn);
          interceptCheckoutButtons();
        }
      }
    }
  }

  var reinjectTimer;
  var drawerObserver = new MutationObserver(function () {
    clearTimeout(reinjectTimer);
    reinjectTimer = setTimeout(injectUI, 80);
  });

  function init() {
    cleanupProtection();
    injectUI();

    var drawer = document.getElementById("Cart-Drawer");
    if (drawer) drawerObserver.observe(drawer, { childList: true, subtree: true });

    if (window.location.pathname === "/cart") {
      var cartForm = document.querySelector("#Cart, .thb-cart-form");
      if (cartForm) drawerObserver.observe(cartForm, { childList: true, subtree: true });
    }
  }

  window.addEventListener("pageshow", function (e) {
    if (e.persisted) cleanupProtection();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();